// ============================================================
// loading.ts — 画面共通のローディング表示
// ============================================================
//
// 帳票ダウンロードで使っていたオーバーレイを画面全体の共通処理にする。
// 通信中・登録中・帳票生成中で見た目を揃え、待たされている理由を文言で示す。
//
// 同時に複数の処理が走っても二重に表示・解除しないよう参照数で管理し、
// 表示中は自動更新を止めてサーバー負荷の取り合いを避ける。

let active = 0;
let overlay: HTMLElement | null = null;

function ensureOverlay(): HTMLElement {
    if (overlay && document.body.contains(overlay)) {
        return overlay;
    }
    // ページ別バンドルと共通バンドルでモジュールの実体が分かれるため、
    // 既に置かれている要素があればそれを使い、二重に作らない。
    const existing = document.getElementById('nc-loading-overlay');
    if (existing) {
        overlay = existing;
        return existing;
    }
    const el = document.createElement('div');
    el.id = 'nc-loading-overlay';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.innerHTML =
        '<div class="nc-loading-spinner" aria-hidden="true"></div>' +
        '<div class="nc-loading-message"></div>' +
        '<div class="nc-loading-sub"></div>';
    document.body.appendChild(el);
    overlay = el;
    return el;
}

function autoReload(): { pause?: () => void; resume?: () => void } | undefined {
    return (window as unknown as { AutoReload?: { pause?: () => void; resume?: () => void } }).AutoReload;
}

/** 文言を指定してローディングを表示する。呼んだ回数だけ hideLoading が必要。 */
export function showLoading(message = '読み込み中...', sub = ''): void {
    const el = ensureOverlay();
    // 最初に表示した処理の文言を残す。裏で走る一覧更新に上書きさせない。
    if (active === 0) {
        const messageEl = el.querySelector('.nc-loading-message');
        const subEl = el.querySelector('.nc-loading-sub') as HTMLElement | null;
        if (messageEl) { messageEl.textContent = message; }
        if (subEl) { subEl.textContent = sub; subEl.hidden = sub === ''; }
        document.body.classList.add('nc-loading');
        autoReload()?.pause?.();
    }
    active++;
}

export function hideLoading(): void {
    active = Math.max(0, active - 1);
    if (active === 0) {
        document.body.classList.remove('nc-loading');
        autoReload()?.resume?.();
    }
}

/** 表示中かどうか。連続した通信でちらつかせないための判定に使う。 */
export function isLoading(): boolean {
    return active > 0;
}

// インラインスクリプトや jQuery 側からも同じ表示を使えるようにする。
(window as unknown as Record<string, unknown>).NcLoading = { show: showLoading, hide: hideLoading, isLoading };
